/* src/app/shared/dialog/tv-select-items-dialog/tv-select-items-dialog.component.scss */
.container-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 450px;
  margin: 0;
  border-radius: 25px;
  font-size: 13px;
}
.container-options .mat-checkbox-inner-container {
  width: 12px;
  height: 12px;
}
.container-options .search-container {
  margin: 12px 0px;
}
.container-options .full-width {
  width: 100%;
}
.container-options .checkbox-list {
  display: flex;
  flex-direction: column;
  max-height: 250px;
  overflow-y: auto;
  padding: 8px;
}
.container-options .button-group-horizontal {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.search-container {
  margin: 12px 0px;
}
.button-edit {
  justify-content: flex-end;
  display: inline-flex;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.selection-required-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #0083FF;
}
.selection-required-info mat-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}
.channel-logo {
  margin-right: 8px;
  width: 14px;
  height: auto;
}
.checkbox-input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
/*# sourceMappingURL=tv-select-items-dialog.component.css.map */
